<template>
  <tabs parent="services">
    <tab
      id="blocked_simcard"
      :name="translate('services.blocked_simcard.title')"
      :href="url+'blocked_simcard?status=1&simcard_profile_status=2'"
      v-if="$store.getters.getPermissions.permissionGod === true"
    >
      <BlockedSimcard/>
    </tab>
  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import BlockedSimcard from "./Tabs/BlockedSimcard/BlockedSimcard.vue";

export default {
  name: 'Services',
  components:{
    Tab,
    Tabs,
    BlockedSimcard
  },
  computed:{
    url(){ return "/services/"}
  }
}
</script>
